// src/pages/DashboardNavigation/components/TimelineStrip.jsx

import React from "react";

export default function TimelineStrip({ pages, onGoTo }) {
  if (!pages?.length || pages.length <= 1) return null;

  return (
    <div className="mt-2 rounded-2xl bg-slate-50 px-2 py-2 ring-1 ring-slate-200/70 dark:bg-slate-950/60 dark:ring-slate-800">
      <div className="flex items-center gap-1.5 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {pages.map((item) => {
          const clickable = !item.isCurrent;

          let stateClass =
            "bg-white text-slate-400 ring-1 ring-slate-200/80 dark:bg-slate-900 dark:text-slate-500 dark:ring-slate-800";

          if (item.isCurrent) {
            stateClass =
              "bg-slate-950 text-white shadow-sm ring-1 ring-slate-950 dark:bg-white dark:text-slate-950 dark:ring-white";
          }

          if (item.isPrevious) {
            stateClass =
              "bg-orange-100 text-orange-800 ring-1 ring-orange-200 hover:bg-orange-200 dark:bg-orange-950/40 dark:text-orange-100 dark:ring-orange-900/70 dark:hover:bg-orange-950/60";
          }

          if (item.isNext) {
            stateClass =
              "bg-sky-100 text-sky-800 ring-1 ring-sky-200 hover:bg-sky-200 dark:bg-sky-950/40 dark:text-sky-100 dark:ring-sky-900/70 dark:hover:bg-sky-950/60";
          }

          return (
            <button
              key={item.path}
              type="button"
              disabled={!clickable}
              onClick={() => onGoTo(item.path)}
              aria-current={item.isCurrent ? "page" : undefined}
              title={item.label}
              className={[
                "shrink-0 rounded-full px-3 py-1.5 text-[11px] font-bold transition",
                stateClass,
                clickable
                  ? "cursor-pointer active:scale-[0.98]"
                  : "cursor-default",
              ].join(" ")}
            >
              <span className="hidden sm:inline">{item.index + 1}. </span>
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}